<template>
	<div v-bind="$attrs" class="bg-home"></div>
	<div v-bind="$attrs" class="main-screen">

		<!-- FIRST SCREEN -->
		<div class="section first">
			<a href="/steal-estate/" class="logo animated" ref="logo">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/02_Logo.png" alt="Logo">
			</a>

			<div @click="scroll('second')" class="scroll-down">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/03_Scroll.png" alt="">
			</div>
		</div>
		<!-- // FIRST SCREEN -->

		<!-- TWO SCREEN -->
		<div class="section second" ref="second" id="second">
			<div class="title animated">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/04_Title.png" alt="">
			</div>

			<div class="text show">
				<div class="inner">
					<p class="animated">{{ lang('home_1') }}</p>
					<p class="animated text-center bold">{{ lang('home_2') }}</p>
					<p class="animated small"><i>{{ lang('home_3') }}</i></p>
				</div>
			</div>

			<div @click="scroll('third')" class="scroll-down animated">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/05_OpenCases.png" alt="">
			</div>

			<div class="group-image" ref="plan">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/05_BackgroundElementsLeft.png"
					alt="">
				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/05_BackgroundElementsRight.png"
					alt="">
			</div>
		</div>
		<!-- // TWO SCREEN -->

		<!-- THREE SCREEN -->
		<div class="section third" ref="third">
			<div class="group-image show board">
				<!-- <a class="btn-link" href="/steal-estate/resources/">
					<img src="/themes/rise-theme/dist/images/estate/TakeAction@2x.png" alt="">
					<img src="/themes/rise-theme/dist/images/estate/TakeAction@2xRO.png" alt="">
				</a> -->

				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/CasesBoard_Background@2x.png"
					alt="" class="bg">

				<div class="vanessa profile animated">
					<router-link to="/character/vanessa">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png)">
					</div>
				</div>
				<div class="holy profile animated">
					<router-link to="/character/holly">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png)">
					</div>
				</div>
				<div class="henry profile animated">
					<router-link to="/character/henry">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png)">
					</div>
				</div>
				<div class="ozzie profile animated">
					<router-link to="/character/ozzie">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png)">
					</div>
				</div>
				<div class="villain profile animated">
					<router-link to="/character/villian">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png)">
					</div>
				</div>
			</div>
			<div class="intro_hand1"></div>
			<div class="intro_hand2"></div>
		</div>
		<langControl/>
		<!-- // THREE SCREEN -->
	</div>
	<div v-bind="$attrs" >
		<IntroHelp :show-modal="store.showTutorial" />
	</div>
</template>

<script>

import { store } from './store.js'
import helpers from '../util/helpers';
import IntroHelp from './components/IntroHelp.vue';
import langControl from '../components/langControl.vue'

export default {
	components: {
		IntroHelp,
		langControl,
	},
	data() {
		return {
			store
		};
	},
	provide() {
		return {
			helpers,
		};
	},
	inject: ['lang'],
	methods: {
		animated() {
			const elems = document.querySelectorAll('.animated');
			const options = {
				rootMargin: '0px',
			}

			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					window.requestAnimationFrame(() => {
						entry.target.classList.toggle('show', entry.isIntersecting);
					});
				});
			}, options);

			elems.forEach(elem => {
				observer.observe(elem);
			});
		},
		animatedScroll() {
			const second = this.$refs.second;
			const third = this.$refs.third;
			const logo = this.$refs.logo;
			const plan = this.$refs.plan;
			const logoWidth = logo.clientWidth;
			let count = 1;

			window.addEventListener('scroll', () => {
				if (window.scrollY < second.getBoundingClientRect().top) {
					logo.style.width = (logoWidth - (window.scrollY / 1)) + 'px';
				}

				if (window.scrollY + (second.getBoundingClientRect().height / 4) > second.getBoundingClientRect().top && window.scrollY < third.getBoundingClientRect().top + window.innerHeight + 300) {
					plan.classList.add('show');

					let y = -300 + (window.scrollY / 1.5);
					let op = count - (window.scrollY / 1200);

					plan.style.bottom = `${y}px`;
					plan.style.opacity = op;
				} else {
					// plan.classList.remove('show');
					// plan.style.opacity = 0;
				}
			});
		},
		scroll(e) {
			let elem = null;

			if (e == 'second') {
				elem = this.$refs['second'];
			} else if (e == 'third') {
				elem = this.$refs['third'];
			}

			const pos = elem.getBoundingClientRect().top + window.scrollY;
			window.scrollTo({ top: pos, behavior: 'smooth' });
		}
	},
	mounted() {

		document.querySelector('div.microsite-estate-home').style.display = 'none';

		/* CHROME SCROLL START
		------------------------------------ */
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		this.animatedScroll();
		this.animated();
		const ch_images = document.getElementsByClassName("character-icon");
		let orig_src = '';
		for (let i = 0; i < ch_images.length; i++) {
			ch_images[i].addEventListener('mouseover', e => {
				orig_src = e.target.getAttribute('src');
				e.target.setAttribute('src', e.target.dataset.glowSrc)
			}, false);
			ch_images[i].addEventListener('mouseleave', e => {
				e.target.setAttribute('src', orig_src)
			}, false);
		}

	},
	unmounted() {
		document.querySelector('div.microsite-estate-home').style.display = 'block';
	},
}

</script>

<style lang="scss" scoped>
.section {
	color: #ffffff;
}

img {
	max-width: 100%;
}

.disabled {
	pointer-events: none;

	img {
		filter: brightness(0.35);
	}
}

.main-screen {
	background: #000 url('/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/01_IntroBackground.png') no-repeat fixed center;
	background-size: cover;

	@media(max-width: 1367px) {
		background: none;
	}
}

.bg-home {
	@media(max-width: 1367px) {
		background: #000 url('/themes/rise-theme/dist/images/estate/character-view/villian/01_IntroBackground.png') no-repeat center;
		background-size: cover;
		height: 100vh;
		width: 100vw;
		position: fixed;
		z-index: 0;
	}
}

.btn-link {
	position: absolute;
	top: calc(50% - 260px);
	right: 55px;
	max-width: 450px;

	img:last-child {display: none;}
	&:hover img:last-child {display: block;}
	&:hover img:first-child {display: none;}

	@media(max-width: 1500px) {
		top: calc(50% - 215px);
		right: 40px;
		max-width: 400px;
	}

	@media(max-width: 1200px) {
		top: calc(50% - 160px);
	    right: 35px;
	    max-width: 350px;
	}

	@media(max-width: 991px) {
		top: calc(50% - 120px);
	    right: 30px;
	    max-width: 300px;
	}

	@media(max-width: 600px) {
		top: 44px;
		right: initial;
		left: -95px;
		max-width: 285px;
		transform-origin: right center;
		transform: rotate(-90deg);
	}
}

.section {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	position: relative;
	z-index: 2;

	.logo {
		width: 300px;
		min-width: 200px;
		position: fixed;
		top: 50px;
		left: 50%;
		transform: translateX(-50%);
		transition: width 0s linear;

		@media(min-width: 600px) and (max-width: 1280px) {
			max-width: 200px;
		}
	}

	.scroll-down {
		position: absolute;
		left: 50%;
		bottom: 50px;
		transform: translateX(-50%);
		max-width: 90px;
		margin-left: -20px;
		cursor: pointer;

		@media(max-width: 600px) {
			bottom: calc(50% - 120px);
		}
	}

	.title {
		max-width: 500px;
		transition: all 0.3s;
		transform: translateY(100%);
		opacity: 0;

		@media(min-width: 600px) and (max-width: 1280px) {
			text-align: center;

			img {
				max-width: 60%;
			}
		}

		&.show {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.text {
		background: rgba(0, 0, 0, .7);
		border-radius: 15px;
		padding: 30px;
		max-width: 800px;
		transition: all 1s;
		transform: scale(0);
		position: relative;
		z-index: 3;
		font-family: "american-typewriter", "Courier New", Courier, monospace;
		font-size: 1rem;
		line-height: 1.5rem;

		&.show {
			transform: scale(1);

			@media(min-width: 600px) and (max-width: 1280px) {
				transform: scale(0.65);
				max-width: 100%;
			}
		}

		.bold {
			font-family: "AmericanTypewriter-Bold", "Courier New", Courier, monospace;
		}

		p+p {
			margin-top: 25px;
		}

		p {
			opacity: 0;
			transition: all 0.3s 0.5s;

			&:first-child {
				transition: all 0.3s 0.5s;
			}

			&:last-child {
				transition: all 0.3s 1s;
			}
		}

		p.show {
			opacity: 1;
		}
	}
}

.section.second {
	.scroll-down {
		bottom: -40px;
		transform: translate(-50%, 100%);
		transition: all 1s 1s;
		opacity: 0;

		&.show {
			transform: translate(-50%, 0);
			opacity: 1;

			@media (max-width: 600px) {
				transform: translate(-50%, 13vh);
			}
		}
	}

	.group-image {
		position: fixed;
		left: 0;
		right: 0;
		bottom: -200px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		transition: opacity 0.3s linear;
		opacity: 0;
		pointer-events: none;

		&.show {
			opacity: 0.3;
		}

		img:first-child {
			max-width: 250px;
			margin-left: -45px;

			@media(min-width: 600px) and (max-width: 1280px) {
				max-width: 200px;
				margin-left: -45px;
				margin-bottom: 40px;
			}
		}

		img:last-child {
			max-width: 550px;
			margin-right: -250px;

			@media(min-width: 600px) and (max-width: 1280px) {
				max-width: 370px;
				margin-right: -100px;
				margin-bottom: 40px;
			}
		}
	}

	@media (max-width: 600px) {
		height: auto;
	}
}

.section.third {
	position: relative;
	overflow: hidden;
	align-items: flex-start;

	@media(max-width: 600px) {
		min-height: 100vh;
		align-items: center;
	}

	.intro_hand1 {
		width: 290px;
		height: 900px;
		position: absolute;
		background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_01.png');
		background-size: contain;
		background-repeat: no-repeat;
		top: calc(50% + 185px);
		left: 50%;
		transform: translateX(-50%);
		margin-left: -570px;

		@media (max-width: 1500px) {
			top: calc(50% + 120px);
			margin-left: -450px;
		}

		@media (max-width: 1200px) {
			top: calc(50% + 50px);
			margin-left: -340px;
		}

		@media (max-width: 991px) {
			top: calc(50% + 20px);
			margin-left: -270px;
		}

		@media(max-width:600px) {
			top: calc(50% + 105px);
			left: calc(50% - 257px);
			width: 200px;
		}
	}

	.intro_hand2 {
		width: 400px;
		height: 900px;
		position: absolute;
		background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_02.png');
		background-size: contain;
		background-repeat: no-repeat;
		top: calc(50% + 267px);
		left: 50%;
		transform: translateX(-50%);
		margin-left: 550px;

		@media (max-width: 1500px) {
			top: calc(50% + 200px);
			margin-left: 460px;
		}

		@media (max-width: 1200px) {
			top: calc(50% + 131px);
			margin-left: 360px;
		}

		@media (max-width: 991px) {
			top: calc(50% + 85px);
			margin-left: 290px;
		}

		@media(max-width:600px) {
			top: calc(50% + 146px);
			left: calc(50% + 36px);
			width: 300px;
		}
	}

	.group-image {
		transition: opacity 0.3s 1s linear;
		position: relative;
		bottom: 0;
		left: 50%;
		margin-right: 0;
		max-width: 1500px;
		transform: translateX(-50%);
		margin-left: -185px;

		&>img {
			max-width: 100%;
		}

		.profile {
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 1;
			width: 200px;
			transform: translate(-50%, -50%) scale(1);
			transition: transform 0.3s 0.5s;

			&.disabled {
				pointer-events: none;

				img {
					filter: brightness(0.35);
				}
			}

			img {
				width: 100%;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 97px 19px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}
			}

			&.vanessa {
				margin-left: -7.8%;
				margin-top: -5%;

				@media(max-width:600px) {
					margin-top: 12%;
				}

				img {
					&:hover {
						transform-origin: 80px 35px;
					}
				}
			}

			&.holy {
				margin-left: 6%;
				margin-top: -3.8%;

				@media(max-width:600px) {
					margin-left: 8%;
					margin-top: 12.2%;
				}

				img {
					&:hover {
						transform-origin: 98px 25px;
					}
				}
			}

			&.henry {
				margin-top: 11.7%;
				margin-left: -8.5%;

				@media(max-width:600px) {
					margin-top: -8.3%;
				}

				img {
					&:hover {
						transform-origin: 90px 31px;
					}
				}
			}

			&.ozzie {
				margin-left: 7.5%;
				margin-top: 12%;

				@media(max-width:600px) {
					margin-top: -7%;
				}

				img {
					&:hover {
						transform-origin: 96px 30px;
					}
				}
			}

			@media (max-width: 1200px) {
				width: 140px;
			}

			@media (max-width: 991px) {
				width: 115px;
			}

			@media(max-width: 600px) {
				left: 46%;
				top: 32%;
				transform-origin: center;
				transform: rotate(-90deg);
			}
		}

		.villain {
			position: absolute;
			left: calc(83% - 30px);
			top: calc(66% - 100px);
			z-index: 2;
			width: 300px;
			transition: opacity 0.3s 1s;

			img {
				height: 260px;
				width: auto;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 151px 28px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}

			}

			@media (max-width: 1500px) {
				left: calc(83% - 30px);
				top: calc(66% - 100px);
				width: 250px;

				img {
					height: 240px;
				}
			}

			@media (max-width: 1200px) {
				left: calc(83% - 30px);
				top: calc(74% - 100px);
				width: 200px;

				img {
					height: 200px;
				}
			}

			@media (max-width: 991px) {
				left: calc(86% - 50px);
				top: calc(70% - 60px);
				width: 150px;

				img {
					height: 160px;
				}
			}

			@media(max-width: 600px) {
				left: calc(77% - 45px);
				top: calc(50% - 60px);
				width: 150px;

				img {
					height: 150px;
				}
			}
		}

		&.show {
			opacity: 1;
		}

		@media (max-width: 1500px) {
			max-width: 1200px;
			margin-left: -148px;
		}

		@media (max-width: 1200px) {
			max-width: 900px;
			margin-left: -110px;
		}

		@media (max-width: 991px) {
			max-width: 700px;
			margin-left: -90px;
		}

		@media(max-width: 600px) {
			top: -13.3vh;
			transform: rotate(90deg) translateY(50%);
			transform-origin: center;
			min-width: 700px;
			margin-left: 0;
		}

		@media(max-width: 393px) {
			transform: rotate(90deg) translateY(47%);
		}

		@media(max-width: 390px) {
			transform: rotate(90deg) translateY(45%);
		}

		@media(max-width: 375px) {
			transform: rotate(90deg) translateY(47%);
		}

		@media(max-width: 360px) {
			transform: rotate(90deg) translateY(43%);
		}
	}
}

.group-image {
	&>.animated {
		img {
			&:hover {
				animation: swing ease-in-out 3s alternate;
				transform-origin: 6vw 3vw; // 99 31
				animation-iteration-count: infinite;
				transition: transform 0.5s ease-in-out;
			}
		}
	}
}

@media screen and (max-width: 1300px) {
	.section .text {
		max-width: 700px;
	}
}

@media screen and (max-width: 768px) {
	.section .logo {
		width: 400px;
	}
}

@media screen and (max-width: 650px) {
	.section .logo {
		width: 170px;
		min-width: 90px;
	}

	.section .title {
		max-width: 300px;
	}

	.section .text.show {
		margin-left: 15px;
		margin-right: 15px;
	}

	.section.second .group-image img:first-child {
		width: 150px;
	}

	.section.second .group-image img:last-child {
		width: 350px;
		margin-right: -200px;
	}

	.section.second .scroll-down {
		bottom: -50px;
	}

}
</style>
